import mapSceneToComponent from '../mapSceneToComponent.js'
import script from './factory.json'
import { factory } from '../locations.js'

export const Scene = (scene) => () => {
  return (
    <>
      {scene.map(mapSceneToComponent)}
    </>
  )
}

const scenes = script.scenes

// Generated from Siege_Business_message_and_map_v6.docx (script_stuff/POSTGRAD game files) by the
// script-to-stories skill. Location names in the v6 docx are canonical; each
// path maps 'Theater' to its own factory* constant so markers from parallel
// paths don't stack. 'DIRECT' / 'NONE' entries are null.
const conversations = [
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null, // NONE
  null // NONE
]

const markers = [
  { location: factory, text: 'Meet at the Theater.' }, // docx loc: 'Theater'
  { location: factory, text: 'Do car bit.' }, // docx loc: 'Theater'
  { location: factory, text: 'Confirm inspection time.' }, // docx loc: 'Theater'
  { location: factory, text: 'Phone message from a Giles.' }, // docx loc: 'Theater'
  { location: factory, text: 'Talk to Junior about eviction' }, // docx loc: 'Theater'
  { location: factory, text: 'What did the engineer find out?' }, // docx loc: 'Theater'
  { location: factory, text: 'Does Bel have a plan?' }, // docx loc: 'Theater'
  { location: factory, text: 'Better tell Junior…' }, // docx loc: 'Theater'
  { location: factory, text: 'Make Junior do his bit.' }, // docx loc: 'Theater'
  { location: factory, text: 'See what Junior wanted to say.' }, // docx loc: 'Theater'
  { location: factory, text: 'Maybe it\'s worth finding out.' }, // docx loc: 'Theater'
  { location: factory, text: 'The Attenborough bit.' }, // docx loc: 'Theater'
  { location: factory, text: 'Meet Lex from Immaculate Construction' }, // docx loc: 'Theater'
  { location: factory, text: 'Junior\'s solution' }, // docx loc: 'Theater'
  { location: factory, text: 'Hopefully everything is OK with Junior.' }, // docx loc: 'Theater'
  { location: factory, text: 'Did J. visit the chicken farm?' }, // docx loc: 'Theater'
  { location: factory, text: 'Make peace with Junior?' }, // docx loc: 'Theater'
  { location: factory, text: 'What is Junior thinking?' }, // docx loc: 'Theater'
  { location: factory, text: 'Bel is up late.' }, // docx loc: 'Theater'
  { location: factory, text: 'Running out of time.' } // docx loc: 'Theater'
]

const teasers = [
  'Better have the car bit ready.',
  'What will happen at the inspection?',
  'Is the Giles convinced there is no risk to the public?',
  'What will Junior say about the eviction threat?',
  'Which parts of the theater are actually unsafe?',
  'What did Bel think she could do to the engineer?',
  'Who was the girl in the window?',
  'Will Junior do a bit?',
  'What will the next company record be?',
  'Is there some other engineering solution?',
  'Legalish?',
  'Are things all good with Junior?',
  'But money won\'t solve the problem?',
  'What is Bel\'s solution?',
  'What is going to break next?',
  'Is Junior up to something?',
  'What does Junior expect?',
  'Bel needs to finish her idea.',
  'Who did Bel call?',
  'END of Chapter One.'
]


const art = [
  { url: '/factory/scene1.jpg' },
  { url: '/factory/scene2.jpg' },
  { url: '/factory/scene3.jpg' },
  { url: '/factory/scene4.jpg' },
  { url: '/factory/scene5.jpg' },
  { url: '/factory/scene6.jpg' },
  { url: '/factory/scene7.jpg' },
  { url: '/factory/scene8.jpg' },
  { url: '/factory/scene9.jpg' },
  { url: '/factory/scene10.jpg' },
  { url: '/factory/scene11.jpg' },
  { url: '/factory/scene12.jpg' },
  { url: '/factory/scene13.jpg' },
  { url: '/factory/scene14.jpg' },
  { url: '/factory/scene15.jpg' },
  { url: '/factory/scene16.jpg' },
  { url: '/factory/scene17.jpg' },
  { url: '/factory/scene18.jpg' },
  { url: '/factory/scene19.jpg' },
  { url: '/factory/scene20.jpg' }
]

// AUTO-GENERATED by scripts/deriveTimesOfDay.js — do not hand-edit; rerun `npm run derive-times-of-day` instead.
// Derived from each scene's opening SceneHeading in factory.json.
// (DAY -> afternoon, MORNING -> morning, EVENING -> evening, NIGHT -> evening;
// a CONTINUOUS/LATER opening heading inherits the previous scene's slot.)
const timesOfDay = [
  'morning', // 0: INT. LOBBY - MORNING
  'afternoon', // 1: INT. LOBBY - AT TICKET COUNTER - DAY
  'afternoon', // 2: INT. LOBBY - INSIDE THE ENTRANCE DOORS - DAY
  'evening', // 3: EXT. OUTSIDE ENTRANCE DOORS OF THE THEATER - EVENING
  'morning', // 4: INT. LOBBY - AT TICKET COUNTER - MORNING
  'afternoon', // 5: INT. LOBBY - AT TICKET COUNTER - DAY
  'afternoon', // 6: EXT. OUTSIDE ENTRANCE DOORS OF THE THEATER - DAY
  'morning', // 7: EXT. IN FRONT OF THEATER - MORNING
  'afternoon', // 8: INT. LOBBY - AT TICKET COUNTER - DAY
  'afternoon', // 9: INT. COMMERCIAL KITCHEN OF THEATER - DAY
  'morning', // 10: INT. LOBBY - AT TICKET COUNTER - MORNING
  'afternoon', // 11: INT. THE FRUITING ROOM THEATER - DAY
  'evening', // 12: INT. ALLEY SPORTS BAR - EVENING
  'evening', // 13: INT. LOBBY - UNDER THE LONE BULB - NIGHT
  'afternoon', // 14: INT. THE PLASTIC LAB - DAY
  'morning', // 15: INT. COMMERCIAL KITCHEN OF THEATER - MORNING
  'afternoon', // 16: INT. LOBBY - AT TICKET COUNTER - DAY
  'morning', // 17: INT. COMMERCIAL KITCHEN OF THEATER - MORNING
  'evening', // 18: INT. BEL'S THEATER BEDROOM - NIGHT
  'evening', // 19: INT. LOBBY - AT TICKET COUNTER - EVENING
]

const stories = scenes.map((scene, i) => ({
  timeOfDay: timesOfDay[i],
  sceneArt: art[i],
  scene,
  conversation: conversations[i] || undefined,
  marker: markers[i] || undefined,
  teaser: teasers[i] || undefined
}))

export default stories
